import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { PlayGroundWrapper } = await import('./PlayGroundWrapper');
    return {
        Component: PlayGroundWrapper,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
